import './Progess.scss'

function FlowProgress({
    percent = 0,
    size = 120,
    strokeWidth = 8,
    color = '#1677ff',
    lightColor = '#ffffff',
    speed = 1.2,
}) {
    const radius = (size - strokeWidth) / 2
    const circumference = 2 * Math.PI * radius
    const arcLength = circumference * (Math.min(percent, 100) / 100)
    const lightLen = Math.min(10, arcLength / 3)
    const lightStrokeWidth = Math.max(0.8, strokeWidth * 0.5)
    const isDone = percent >= 100
    const activeColor = isDone ? '#52c41a' : color

    return (
        <div className='flow-progress-wrap' style={{ width: size, height: size }}>
            <svg width={size} height={size} className='flow-progress-svg'>
                {/* 背景圆环 */}
                <circle cx={size / 2} cy={size / 2} r={radius} fill='none' stroke='#f0f0f0' strokeWidth={strokeWidth} />

                {/* 进度弧线 */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill='none'
                    stroke={activeColor}
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeDasharray={`${arcLength} ${circumference - arcLength}`}
                    strokeDashoffset={0}
                    transform={`rotate(-90 ${size / 2} ${size / 2})`}
                />

                {/* 流动光点 —— 仅加载中显示 */}
                {!isDone && (
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill='none'
                        stroke={lightColor}
                        strokeWidth={lightStrokeWidth}
                        strokeLinecap='round'
                        className='flow-light-circle'
                        style={{
                            '--light-len': `${lightLen}px`,
                            '--circle-len': `${circumference}px`,
                            '--arc-len': `${arcLength}px`,
                            '--speed': `${speed}s`,
                        }}
                        transform={`rotate(-90 ${size / 2} ${size / 2})`}
                    />
                )}

                {isDone && (
                    <path
                        d={`M${size * 0.38} ${size * 0.5} L${size * 0.47} ${size * 0.58} L${size * 0.62} ${
                            size * 0.42
                        }`}
                        fill='none'
                        stroke='#52c41a'
                        strokeWidth={Math.max(2, strokeWidth * 0.6)}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                )}
            </svg>

            <div
                className='flow-progress-text'
                style={{
                    fontSize: size * 0.30,
                    opacity: isDone ? 0 : 1,
                    transition: 'opacity 0.2s',
                }}
            >
                {Math.round(percent)}%
            </div>

            {isDone && (
                <div
                    className='flow-progress-check'
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <svg width={size * 0.4} height={size * 0.3} viewBox='0 0 24 18'>
                        <path
                            d='M2 10 L8 16 L22 2'
                            fill='none'
                            stroke='#52c41a'
                            strokeWidth='1'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                </div>
            )}
        </div>
    )
}

export default FlowProgress
